import axios from "axios";

const api = {
  state() {
    return {
      url: process.env.VUE_APP_ROOT_API,
    };
  },
  getters: {
    url(state) {
      return state.url;
    },
  },
  actions: {
    async getRequest(context, { api }) {
      return await axios
        .get(`${context.state.url}${api}`)
        .then((res) => {
          return {
            success: true,
            data: res.data,
            useCookies: context.rootState.cookies.useCookies,
          };
        })
        .catch((error) => {
          return {
            success: false,
            error: error?.response?.data?.message,
          };
        });
    },
    async postRequest(context, { api, body }) {
      return await axios
        .post(`${context.state.url}${api}`, body)
        .then((res) => {
          return {
            success: true,
            data: res.data,
            useCookies: context.rootState.cookies.useCookies,
          };
        })
        .catch((error) => {
          return {
            success: false,
            error: error?.response?.data?.message,
          };
        });
    },
    async formRequest(context, { api, form }) {
      return await axios
        .post(`${context.state.url}${api}`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          return {
            success: true,
            data: res.data,
            useCookies: context.rootState.cookies.useCookies,
          };
        })
        .catch((error) => {
          return {
            success: false,
            error: error?.response?.data?.message,
          };
        });
    },
    async s3UploadRequest(_, { url, file }) {
      // Using fetch to avoid default common headers from axios
      try {
        const res = await fetch(url, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type,
          },
        });

        const contentType = res.headers.get("content-type");
        const data =
          contentType && contentType.includes("application/json")
            ? await res.json()
            : await res.text();

        if (!res.ok) {
          return {
            success: false,
            error: data,
          };
        }

        return {
          success: true,
          data,
        };
      } catch (error) {
        return {
          success: false,
          error,
        };
      }
    },
  },
};

export default api;
